import { Flex, Space, Typography } from "antd";
import Utils from "../../utils/functions";

const { Text } = Typography;

export const PageHeader = ({ headerText, fontSize = 25 }) => {
  if (!headerText) {
    return null;
  }

  return (
    <>
      <Text style={{ fontSize }}>
        {`${Utils.firstLettersToUpperCase(headerText?.name?.trim())}`}
      </Text>
      <Flex>
        <Space flex="row">
          <Text>
            {`Created on ${Utils.formatDate.toLocaleDateString(
              headerText?.createdAt
            )}`}
          </Text>
          .
          <Text>
            {`Last updated on ${Utils.formatDate.toLocaleString(
              headerText?.lastModifiedAt
            )}`}
          </Text>
        </Space>
      </Flex>
    </>
  );
};

export default PageHeader